var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatHandover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.475 24.264h14.398M33.123 18.53l5.835 5.744-5.835 5.745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M36.416 12.823a4.705 4.705 0 00-4.17-2.517H10.153a4.71 4.71 0 00-4.71 4.71v12.078a4.71 4.71 0 004.71 4.71h4.034M14.245 32.008v5.746c.058.219 8.51-5.949 8.51-5.949h5.073"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 16.657,
    cy: 24.036,
    r: 1.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M12.687 17.982h10.818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHandover);
export default __webpack_public_path__ + "static/media/chatHandover.160804114f2e820faebeab7bdd7d068b.svg";
export { ForwardRef as ReactComponent };